import { Stack, Typography } from "@mui/material";
import BasicTooltip from "src/components/BasicTooltip";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

export default function TitleLabel() {
	const { translate } = useLocales();
	return (
		<Stack flexDirection={"row"} alignItems={"center"} gap={1}>
			<Typography variant='body1' fontSize={14} color='text.secondary'>
				{"Logo"}
			</Typography>
			<BasicTooltip title={translate("logo_selector.select_tooltip")}>
				<Iconify color='text.secondary' icon={"ic:outline-info"} width={16} />
			</BasicTooltip>
		</Stack>
	);
}
